import { SubsInput } from "@/domain/dtos/inputs";
import { Plan } from "@/domain/entities";
import { SubsRepository } from "../../domain/repositories";
import { SubsDataSource } from "../datasources/subs";
import { PlanResponse } from "../dtos/responses";
import { PlanMapper, SubsMapper } from "../mappers";

export class SubsRepoImpl implements SubsRepository {
  constructor(
    private readonly dataSource: SubsDataSource,
    private readonly subsMapper: SubsMapper,
    private readonly planMapper: PlanMapper,
  ) {}

  async listPlans() {
    const data = await this.dataSource.listPlans();
    return data.map((elem: PlanResponse) => this.planMapper.toDomain(elem));
  }

  subscribe = async (params: SubsInput) => {
    const data = await this.dataSource.subscribe(params);
    return this.subsMapper.toDomain(data);
  };

  reactivateSubs = (id: number) => {
    return this.dataSource.reactivateSubs(id);
  };

  manualPaymentSubs = (id: number) => {
    return this.dataSource.manualPaymentSubs(id);
  };

  cancelSubs = (id: number) => {
    return this.dataSource.cancelSubs(id);
  };

  showSubs = async (id: number) => {
    if (!id) {
      throw new Error("Erro ao buscar assinatura");
    }

    const data = await this.dataSource.showSubs(id);

    return this.subsMapper.toDomain(data);
  };

  updateSubs = (id: number, params: { card_id: string }) => {
    return this.dataSource.updateSubs(id, params);
  };

  async getPlanDetails(): Promise<Plan> {
    const data = await this.dataSource.getPlanDetails();
    return this.planMapper.toDomain(data);
  }
}
